(function () {
	'use strict';

	angular
		.module('app.supplyChain')
		.controller('openCustomerOrders', openCustomerOrders);

	openCustomerOrders.$inject = ['$scope', '$timeout', '$rootScope', '$state',
		'$location', 'redirectParamsService', 'leanFilterService',
		'tableService', 'navigationService', 'pageTimingService', 'storeService', 'supplyChainReportColumns', 'uploadPOModalService', '$uibModal'
	];

	function openCustomerOrders($scope, $timeout, $rootScope, $state, $location,
			redirectParamsService, leanFilterService, tableService, navigationService, pageTimingService, storeService, supplyChainReportColumns, uploadPOModalService, $uibModal) {
		var vm = this;
		var unsubscribe;
		var timingCalled = false;
		var getDataCalled = false;
		var showRowsCalled = false;
		var pinnedColumnList = [];
		var columnList = columns();

		var reportSettingsName = 'open-customer-orders';
		var baseReportName = 'Open Customer Orders';

		vm.getMeta = getMeta;

		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		vm.reportName = baseReportName;
		vm.showExcel = true;
		vm.useReactReport = true;

		var userTimingListener = $scope.$on('showRowsCalled', function () {
			showRowsCalled = true;
			submitUserTiming();
		});
		$scope.$on('$destroy', function () {
			userTimingListener();
		});

		function submitUserTiming() {
			if (getDataCalled && showRowsCalled && !timingCalled) {
				pageTimingService.submitUserTiming(baseReportName);
				timingCalled = true;
			}
		}

		var rendererParams = {
			multiFactory: true
		};
		var extraParams = [{}];

		var defaultFilters = [];

		function getMeta() {
			return {
				reportSettingsName: reportSettingsName,
				reportSettingsId: reportSettingsId,
				reportUrl: '{0}/OpenCustomerOrdersReport',
				noPaging: false,
				pageSize: 50,
				defaultSort: 'customerOrderDueDate',
				defaultSortDirection: 'asc',
				defaultFilters: defaultFilters,
				rendererParams: rendererParams,
				extraParams: extraParams,
				columns: columnList,
				pinnedColumns: pinnedColumnList,
				hideSearch: false,
				footer: false,
				setColumnDefaults: true,
				excelRequest: true,
				useReportBuilderForExcel: true,
				excelReportName: 'OpenCustomerOrders',
				searchType: 'item'
			};
		}

		function columns() {
			var columns = [];
			return columns;
		}

		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = vm.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

	}
})(); 